import $ from "jquery";
const toggle = (e) => {
    const allTabs = $(e.target).siblings();
    $(allTabs).removeClass("tab-selected");
    allTabs.each((i, e) => {
        $($(e).data("tab-target")).removeClass("active");
    });
    $(e.target).addClass("tab-selected");
    $($(e.target).data("tab-target")).addClass("active");
};
$(document).on("click", ".tab", toggle);
